import { Pipe, PipeTransform } from "@angular/core";
import { toEuroByFiatId } from "@helpers/tradable-convert";
import { Fiat } from "@models";

@Pipe({
	name: "user_fiat_to_eur",
	standalone: false
})
export class UserFiatToEuroPipe implements PipeTransform {
	transform(balance: number, fiat: Fiat): number {
		return toEuroByFiatId(balance, fiat);
	}
}
